export const API_ENDPOINTS = {
  auth: {
    getSession: '/v1/access-control/public/login',
    refresh: '/v1/access-control/public/refresh-token',
    login: '/v1/access-control/public/validate-mfa-code',
  },
  user: {
    base: '/v1/access-control/user',
    me: '/v1/access-control/general/user-data',
    clone: '/v1/access-control/user/clone',
    permission: '/v1/access-control/permission',
    userStatus: '/v1/access-control/user-status',
    byId: (id: string) => `/v1/access-control/user/${id}`,
    resetPassword: '/v1/access-control/public/reset-password',
    forceResetPassword: '/v1/access-control/general/force-reset-password',
    changePassword: '/v1/access-control/public/invalidate-change-password',
    sendVerificationCode: '/v1/access-control/public/send-verification-code',
    userProfiles: (id: string) => `/v1/access-control/user/${id}/user-profiles`,
  },
  userProfile: {
    base: '/v1/access-control/user-profile',
    byId: (id: string) => `/v1/access-control/user-profile/${id}`,
    permissions: (id: string) =>
      `/v1/access-control/user-profile/${id}/permissions`,
    userCompany: (id: string) =>
      `/v1/access-control/user-profile/${id}/user-company`,
    companyById: (id: string, cpId: string) =>
      `/v1/access-control/user-profile/${id}/user-company/${cpId}`,
    salesOffices: (id: string) =>
      `/v1/access-control/user-profile/${id}/sales-offices`,
    workflowTypes: (id: string) =>
      `/v1/access-control/user-profile/${id}/workflow-types`,
    businessPartners: (id: string) =>
      `/v1/access-control/user-profile/${id}/business-partners`,
  },
  dropdown: {
    user: '/v1/dropdown/common/user',
    plant: '/v1/dropdown/common/plant',
    line: '/v1/dropdown/material/line',
    brand: '/v1/dropdown/material/brand',
    region: '/v1/dropdown/common/region',
    country: '/v1/dropdown/common/country',
    company: '/v1/dropdown/common/company',
    statusSo: '/v1/dropdown/sales/status-so',
    material: '/v1/dropdown/material/material',
    incoterms: '/v1/dropdown/common/incoterms',
    workflowTypes: '/v1/dropdown/workflow/type',
    taxDomicile: '/v1/dropdown/common/tax-domicile',
    channel: '/v1/dropdown/business-partner/channel',
    salesOffices: '/v1/dropdown/common/sales-office',
    statusInvoice: '/v1/dropdown/sales/status-invoice',
    biReportFilters: '/v1/dropdown/sales/sales-filter',
    orderStatus: '/v1/dropdown/sales-order/order-status',
    orderTypeSap: '/v1/dropdown/sales-order/order-type-sap',
    salesSchedule: '/v1/dropdown/sales/report-schedule/status',
    infocentreChannel: '/v1/dropdown/common/infocentre-channel',
    salesDistrict: '/v1/dropdown/business-partner/sales-district',
    distributionChannel: '/v1/dropdown/business-partner/distribution-channel',
    currency: '/v1/dropdown/currency',
    salesArea: '/v1/dropdown/sales-area',
    businessPartner: '/v1/dropdown/business-partner',
    creditLimitStatus: '/v1/dropdown/credit-limit/status-by-code',
    contactType: '/v1/dropdown/business-partner/contact-type',
    creditLimitType: '/v1/dropdown/credit-limit/credit-limit-type',
    creditLimitRoleType: '/v1/dropdown/credit-limit/role-types',
    classification: '/v1/dropdown/case-management/classification',
    subclassification: '/v1/dropdown/case-management/subclassification',
    caseManagementStatus: '/v1/dropdown/case-management/status',
    caseManagementPriority: '/v1/dropdown/case-management/priority',
    caseManagementSolution: '/v1/dropdown/case-management/solution',
    caseManagementContactWay: '/v1/dropdown/case-management/contact-way',
    caseManagementContactType: '/v1/dropdown/case-management/contact-way',
    caseManagementUserFilter: '/v1/dropdown/case-management/user-filter',
    claimReason: '/v1/dropdown/claim/reason',
    claimSubReason: '/v1/dropdown/claim/subreason',
    claimStatus: '/v1/dropdown/claim/status',
    claimRootCause: '/v1/dropdown/claim/root-cause',
    claimCorrectiveAction: '/v1/dropdown/claim/corrective-action',
    businessPartnerStatus: '/v1/dropdown/business-partner/status',
    businessPartnerLevel: '/v1/dropdown/business-partner/customer-tiering-tier',
    businessPartnerClassification:
      '/v1/dropdown/business-partner/customer-tiering-channel-type',
    businessPartnerPurchaseGroup:
      '/v1/dropdown/business-partner/purchase-group',
    salesOrderType: '/v1/dropdown/sales-order/sales-order-type',
    businessPartnerPaymentTerm: (id: string) =>
      `/v1/dropdown/business-partner/${id}/payment-term`,
    businessPartnerDestination: '/v1/dropdown/business-partner/destination',
    businessPartnerPriceGroup: '/v1/dropdown/business-partner/price-group',
    businessPartnerOrderBlocking:
      '/v1/dropdown/business-partner/order-blocking',
    discountExceptionTypeDropdown: '/v1/dropdown/price/configuration-types',
    contractStatus: '/v1/dropdown/contract/status',
    contractType: '/v1/dropdown/contract/type',
    salesOrderRigid: '/v1/dropdown/sales-order/sales-order-rigid',
    priceTables: '/v1/dropdown/price/tables',
    materials: '/v1/dropdown/price/table/materials',
    expiration: '/v1/dropdown/contract/expiration-date',
    route: '/v1/dropdown/business-partner/route',
    businessPartnerRoute: (id: string) =>
      `/v1/dropdown/business-partner/${id}/routes`,
  },
  workflow: {
    status: '/v1/workflow/status',
    document: '/v1/workflow/document',
    delegate: '/v1/workflow/document/delegate',
    viewer: (id: string) => `/v1/workflow/viewer/${id}`,
    delete: (id: string) => `/v1/workflow/document/${id}`,
    approver: (id: string) => `/v1/workflow/approver/${id}`,
    groupUsers: (id: string) => `/v1/workflow/group/${id}/users`,
    history: (id: string) => `/v1/workflow/document/history/${id}`,
  },
  workflowDoc: {
    create: '/v1/workflow/document',
    update: '/v1/workflow/document',
    reject: '/v1/workflow/document/reject',
    approve: '/v1/workflow/document/approve',
    byId: (id: string) => `/v1/workflow/document/${id}`,
    downloadFile: '/v1/workflow/public/document/download-file',
    uploadFile: 'v1/workflow/document/upload-file',
  },
  workflowType: {
    base: '/v1/workflow/type',
    create: '/v1/workflow/type',
    byId: (id: string) => `/v1/workflow/type/${id}`,
    uploadFile: (id: string) => `/v1/workflow/type/${id}/uploadfile`,
    downloadFile: (id: string) => `/v1/workflow/type/${id}d/uploadfile`,
  },
  workflowGroup: {
    base: '/v1/workflow/group',
    createGroup: '/v1/workflow/group',
    byId: (id: string) => `/v1/workflow/group/${id}`,
    approvalInGroup: (id: string) => `/v1/workflow/group/${id}/users`,
    approvalInGroupUser: (id: string, userId: string) =>
      `/v1/workflow/group/${id}/users/${userId}`,
  },
  material: {
    listManagerialCost: '/v1/material/managerial-cost',
    manageriaCost: '/v1/import-consumer/cost/import-managerial-cost',
    byId: (id: string) => `/v1/material/material/${id}`,
    accountingCost: 'import-consumer/v1/material/import-accounting-cost',
    manageriaCostById: (id: string) => `/v1/material/managerial-cost/${id}`,
    validateMaterials: (id: string) =>
      `/v1/sales-order/order/materials/${id}/prices`,
    materialHistorySalesOrder: (
      businessPartnerId: string,
      salesOrderTypeId: string,
      materialId: string,
      page: number,
      limit: number
    ) =>
      `/v1/sales-order/order/material/${materialId}/history?businessPartnerId=${businessPartnerId}&salesOrderTypeId=${salesOrderTypeId}&page=${page}&limit=${limit}`,
    downloadTemplateFile: '/v1/sales-order/order/download-template-file',
  },
  businessPartner: {
    byId: (id: string) => `/v1/business-partner/detail/${id}`,
    contacts: '/v1/business-partner/contacts',
    createContact: '/v1/business-partner/contact',
    contactsById: (id: string) => `/v1/business-partner/contacts/${id}`,
    contactById: (id: string) => `/v1/business-partner/contact/${id}`,
    list: '/v1/business-partner/get-list',
    edit: (id: string) => `/v1/business-partner/${id}`,
    salesPartnerlist: '/v1/business-partner/sales-partner',
    update: (id: string) => `/v1/business-partner/${id}`,
    massUpdate: {
      list: '/v1/business-partner/bulk-update/get-list',
      update: '/v1/business-partner/apply-update',
    },
    automotiveDiscount: {
      create: '/v1/business-partner/automotive-discount',
      list: '/v1/business-partner/automotive-discount/get-list',
      delete: (id: string) => `/v1/business-partner/automotive-discount/${id}`,
    },
    businessPartnerRoute: {
      create: '/v1/business-partner/route',
      getList: '/v1/business-partner/routes',
      delete: (id: string) => `/v1/business-partner/route/${id}`,
    },
    businessPartnerFinancialBlock: {
      create: '/v1/business-partner/financial-block',
      getList: '/v1/business-partner/financial-blocks',
      delete: (id: string) => `/v1/business-partner/financial-block/${id}`,
    },
  },
  report: {
    sales: '/v1/commercial-reports/sales-report',
    invoice: '/v1/invoice/report',
    groupedInvoice: '/v1/invoice/groupedreport',
    salesSchedule: '/v1/commercial-reports/report-schedule',
    openinvoices: '/v1/commercial-reports/open-invoices',
    salesPerformance: '/v1/commercial-reports/sales-performance',
    brokerCommission: '/v1/commercial-reports/broker-commission',
    purchaseOrdersReport: '/v1/commercial-reports/extranet-purchase-report',
  },
  salesReport682: {
    report: '/v1/commercial-reports/report-682',
  },
  sap: {
    masks: '/v1/sales-order/masks',
    createMask: '/v1/sales-order/masks',
    salesOrder: '/v1/sales-order/order',
    maskItems: '/v1/sales-order/masks/itens',
    orderList: '/v1/sales-order/order/get-list',
    limitCredit: '/v1/sales-order/order/credit-limit',
    byId: (id: string) => `/v1/sales-order/order/${id}`,
    history: (id: string) => `/v1/sales-order/history/${id}`,
    overrunSalesOrders: '/v1/credit-limit/overrun/sales-order',
    salesOrderData: '/v1/sap/intefaces/get-sales-order-get-data',
    downloadFilesOrderItems: '/v1/sales-order/order/download-file',
    uploadFilesOrderItems: '/v1/sales-order/order/upload-files-itens',
    getOrderStockMaterial: 'v1/sap/intefaces/get-stock-analisis-data',
    desiredDeliveryDate: '/v1/sales-order/order/desired-delivery-date',
    validate: '/v1/sales-order/order/create-or-simulate-sales-order-eu-hana',
    salesOrderHana:
      '/v1/sales-order/order/create-or-simulate-sales-order-eu-hana',
    b2bMaterial: '/v1/sales-order/order/get-material-for-sold-to',
    materialInfo: '/v1/sales-order/order/material-info',
    updateSapCode: (id: string) => `/v1/sales-order/order/fill-sap-code/${id}`,
    releaseSalesOrder: (id: string) =>
      `/v1/sales-order/order/release-order/${id}`,
    refuseSalesOrder: (id: string) => `/v1/sales-order/order/refuse/${id}`,
    commentHistory: (id: string) => `/v1/sales-order/order/${id}/comments`,
    salesOrderWarnings: '/v1/sales-order/order/materials/warnings',
  },
  biReport: {
    list: '/v1/commercial-reports/bi-report',
    filter: '/v1/commercial-reports/bi-report',
    createFilter: '/v1/sales/sales-filter',
    openOrders: '/v1/commercial-reports/open-orders',
    pendingReport: '/v1/commercial-reports/open-orders',
    downloadFile: '/v1/commercial-reports/public/download-sales-file',
    customReport: '/v1/commercial-reports/custom-report',
    filterById: (id: string) => `/v1/sales/sales-filter/${id}`,
    createReporting: '/v1/dropdown/sales/bi-report/custom-report',
    downloadOrderEurope:
      '/v1/commercial-reports/public/download-sales-order-file-europe',
    downloadInvoiceEurope:
      '/v1/commercial-reports/public/download-sales-invoice-file-europe',
  },
  common: {
    menu: '/v1/common/menu',
    company: '/v1/common/company',
    taskList: '/v1/common/task-list',
    transportationZone: (id: string) => `/v1/common/transportation-zone/${id}`,
  },
  import: {
    base: `/v1/import-server/schedule`,
  },
  financial: {
    create: '/v1/credit-limit/request',
    creditLimit: '/v1/credit-limit/request',
    delete: (id: string) => `/v1/credit-limit/request/${id}`,
    history: (id: string) => `/v1/credit-limit/history/approvers/${id}`,
    sendToSap: (id: string) =>
      `/v1/credit-limit/request/send-credit-limit-update/${id}`,
    approvalHistory: (businessPartnerId: string) =>
      `/v1/credit-limit/history/requests/${businessPartnerId}`,
    moreInfo: (id: string) =>
      `/v1/credit-limit/request/send-more-information/${id}`,
    listApprovalCreditLimit: (id: string) => `/v1/credit-limit/request/${id}`,
    downloadFile: '/v1/credit-limit/public/download-file',
    moreInformation: '/v1/credit-limit/request/send-more-information',
    scoreFinancialStatement: `/v1/credit-limit/request/score-financial-statement`,
    importFinancialStatement: `/v1/credit-limit/request/import-financial-statement`,
    approvalCreditLimit: (id: string) => `/v1/credit-limit/request/${id}`,
    creditLimitRating: `/v1/dropdown/credit-limit-rating`,
    creditLimitRatingScore: `/v1/credit-limit/request/score`,
    creditLimitImportRisk: `/v1/credit-limit/request/import-risk`,
    creditLimitFatherBondChange: `/v1/credit-limit/request/classification-audited-statements`,
    salesOfficeLC: (type: string) =>
      `/v1/access-control/general/get-user-sales-office?type=${type}`,
  },
  caseManagement: {
    createProspect: '/v1/case-management/prospect',
    list: '/v1/case-management/get-list',
    pendingCases: '/v1/case-management/pending-case',
    create: '/v1/case-management/case',
    caseById: (id: string) => `/v1/case-management/${id}`,
    createBusinessHours: '/v1/case-management/business-hours',
    deleteCaseById: (id: string) => `/v1/case-management/${id}`,
    listBusinessHours: '/v1/case-management/business-hours',
    getEditBusinessHours: '/v1/case-management/business-hours/edit-view',
    deleteBusinessHours: (id: string) =>
      `/v1/case-management/business-hours/delete/${id}`,
    createSla: '/v1/case-management/sla',
    updateSla: (id: string) => `/v1/case-management/sla/${id}`,
    slaById: (id: string) => `/v1/case-management/sla/${id}`,
    getSla: '/v1/case-management/sla',
    history: (id: string) => `/v1/case-management/history/case/${id}`,
    downloadFile: '/v1/case-management/public/download-file',
  },
  claim: {
    getClaim: (id: string) => `/v1/claim/${id}`,
    list: '/v1/claim/get-list',
    history: (id: string) => `/v1/claim/history/${id}`,
    deleteClaim: (id: string) => `/v1/claim/${id}`,
    uploadFile: '/v1/claim/upload-file',
    downloadFile: '/v1/claim/download-file',
    justification: (id: string) => `/v1/claim/justification/${id}`,
    releaseClaim: (id: string) => `/v1/claim/release/${id}`,
    correctClaim: (id: string) => `/v1/claim/correct/${id}`,
    refuseClaim: (id: string) => `/v1/claim/refuse/${id}`,
    revertClaim: (id: string) => `/v1/claim/revert/${id}`,
    editClaim: (id: string) => `/v1/claim/${id}`,
  },

  pricing: {
    positioningList: '/v1/pricing/automotive/positioning/get-list',
    positioningById: (id: string) => `/v1/pricing/automotive/positioning/${id}`,
    createPositioning: '/v1/pricing/automotive/positioning',
    updatePositioning: (id: string) =>
      `/v1/pricing/automotive/positioning/${id}`,
    deletePositioning: (id: string) =>
      `/v1/pricing/automotive/positioning/${id}`,
    exportPositioning: '/v1/pricing/automotive/positioning/export',
    createPrice: '/v1/pricing/automotive/table',
    list: '/v1/pricing/automotive/table/get-list',
    automotiveDiscountExceptionList: `/v1/pricing/automotive/exceptions/get-list`,
    createDiscountException: '/v1/pricing/automotive/exceptions',
    discountExceptionById: (id: string) =>
      `/v1/pricing/automotive/exceptions/${id}`,
    getExceptionDiscountDetailsList: (priceListId: string) =>
      `/v1/pricing/automotive/exceptions/${priceListId}/configuration/get-list`,
    updateDiscountException: (priceListId: string, configurationId: string) =>
      `/v1/pricing/automotive/exceptions/${priceListId}/configuration/${configurationId}`,
    exceptionDiscountDetails: (priceListId: string, configurationId: string) =>
      `/v1/pricing/automotive/exceptions/${priceListId}/configuration/${configurationId}`,
    exportDownloadFile: (id: string) =>
      `/v1/pricing/automotive/table/${id}/materials/export`,
    exportDownloadFileDiscountException: (id: string) =>
      `/v1/pricing/automotive/exceptions/${id}/configuration/export`,
    updateTableConfigDiscountException: (priceListId: string) =>
      `/v1/pricing/automotive/exceptions/${priceListId}`,
    priceById: (id: string) => `/v1/pricing/automotive/table/${id}`,
    materials: (id: string) => `/v1/pricing/automotive/table/${id}/materials`,
    history: (id: string, priceListId: string) =>
      `/v1/pricing/automotive/table/${priceListId}/materials/${id}/history`,
    materialById: (priceListId: string, materialId: string) =>
      `/v1/pricing/automotive/table/${priceListId}/materials/${materialId}`,
    createTableConfigDiscountException: (id: string) =>
      `/v1/pricing/automotive/exceptions/${id}/configuration`,
    rebate: '/v1/pricing/rebate/get-rebate',
    // Industrial
    industrial: {
      list: '/v1/pricing/industrial/table/get-list',
      createIndustrialPrice: '/v1/pricing/industrial/table',
      priceById: (id: string) => `/v1/pricing/industrial/table/${id}`,
      cubeGroup: {
        cubeGroupById: (id: string) =>
          `/v1/pricing/industrial/cube-group/${id}`,
        updateCubeGroupById: (id: string) =>
          `/v1/pricing/industrial/cube-group/${id}`,
        createCubeGroup: '/v1/pricing/industrial/cube-group',
        list: '/v1/pricing/industrial/cube-group/get-list',
        history: (id: string) =>
          `/v1/pricing/industrial/cube-group/${id}/history`,
        exportList: '/v1/pricing/industrial/cube-group/export',
      },
      materialById: (priceListId: string, materialId: string) =>
        `/v1/pricing/industrial/table/${priceListId}/materials/${materialId}`,
      industrialMaterials: (id: string) =>
        `/v1/pricing/industrial/table/${id}/materials`,
      exportIndustrialFile: (id: string) =>
        `/v1/pricing/industrial/table/${id}/materials/export`,
      delete: (id: string) => `/v1/pricing/industrial/table/${id}`,
      history: (id: string, priceListId: string) =>
        `/v1/pricing/industrial/table/${priceListId}/materials/${id}/history`,
    },
    industrialPositioningCube: {
      list: '/v1/pricing/industrial/positioning/get-list',
      exportIndustrialPositioningCubeFile: `/v1/pricing/industrial/positioning/export`,
      create: '/v1/pricing/industrial/positioning',
      positioningCubeById: (id: string) =>
        `/v1/pricing/industrial/positioning/${id}`,
      history: (id: string) =>
        `/v1/pricing/industrial/positioning/${id}/history`,
    },
    exceptionByChannel: {
      getList: '/v1/pricing/others/exceptions/get-list',
      export: '/v1/pricing/others/exceptions/export',
      createExceptions: '/v1/pricing/others/exceptions',
      exceptionsById: (id: string) => `/v1/pricing/others/exceptions/${id}`,
      delete: (id: string) => `/v1/pricing/others/exceptions/${id}`,
    },
    import: {
      baseFile: '/v1/pricing/import/material-template-file',
      importFile: '/v1/pricing/import/file',
    },
  },
  utility: {
    downloadFile: '/v1/utility/file/download-file',
    uploadFile: '/v1/utility/file/upload-file',
    copyFiles: '/v1/utility/file/copy-files',
  },
  contracts: {
    list: '/v1/contract/get-list',
    byId: (id: string) => `/v1/contract/${id}`,
    create: '/v1/contract/contract',
    createAssociatedBp: (contractId: string) =>
      `/v1/contract/${contractId}/associated-bp`,
    details: (id: string) => `/v1/contract/${id}/associated-bp`,
    comments: (id: string) => `/v1/contract/comment/${id}`,
    update: (contractId: string) => `/v1/contract/${contractId}`,
    delete: (contractId: string, bpId: string) =>
      `/v1/contract/${contractId}/associated-bp/${bpId}`,
    history: (contractId: string) => `/v1/contract/history/${contractId}`,
  },
  contractsReport: {
    list: '/v1/commercial-reports/contract-report',
  },

  edi: {
    skuClient: {
      create: '/v1/edi/sku-client', // TODO: corrigir endpoint na integra��o
    },
    clientFileName: {
      list: '/v1/edi/client/file-name/get-list',
      byId: (id: string) => `/v1/edi/client/file-name/${id}`,
      create: '/v1/edi/client/file-name',
    },
    refNumber: {
      list: '/v1/edi/ref-number/get-list',
      byId: (id: string) => `/v1/edi/ref-number/${id}`,
      create: '/v1/edi/ref-number',
    },
  },
}
